
import React from 'react';
import { Loader2, ArrowRight, Check } from 'lucide-react';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { featuresLifetime } from '../PlanFeatures';

interface LifetimePlanProps {
  isProcessing: string | null;
  onSelectPlan: (plan: 'lifetime') => void;
}

const LifetimePlan: React.FC<LifetimePlanProps> = ({ isProcessing, onSelectPlan }) => {
  return (
    <Card className="border border-primary/50 bg-card/30 backdrop-blur-sm shadow-[0_0_30px_-5px_rgba(29,185,84,0.2)] transition-all duration-300 overflow-hidden relative">
      <div className="absolute top-0 right-0 p-2">
        <Badge className="bg-primary/80 text-primary-foreground text-xs font-medium">
          BEST DEAL
        </Badge>
      </div>
      <div className="p-6 space-y-2">
        <h3 className="text-2xl font-bold">Lifetime</h3>
        <div className="flex items-end gap-2">
          <span className="text-4xl font-bold">$199</span>
          <span className="text-muted-foreground">one-time</span>
        </div>
        <p className="text-sm text-primary">Limited-Time Offer!</p>
      </div>
      <Separator className="bg-border/20" />
      <CardContent className="pt-6">
        <ul className="space-y-3">
          {featuresLifetime.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check size={18} className="min-w-4 text-green-500 mr-2 mt-0.5" />
              <span className="text-sm">{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      <CardFooter className="flex flex-col space-y-3 pt-0 px-6 pb-6">
        <Button 
          className="w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20 text-base py-6 group"
          onClick={() => onSelectPlan('lifetime')}
          disabled={isProcessing !== null}
        >
          {isProcessing === 'lifetime' ? (
            <>
              <Loader2 size={16} className="mr-2 animate-spin" />
              Processing...
            </>
          ) : (
            <>
              Get Lifetime Access
              <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
            </>
          )}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default LifetimePlan;
